module.exports = __webpack_public_path__ + "static/media/recentp2.a63dfa61.png";